export default __webpack_public_path__ + "static/media/content-flow.ee024d5d.svg";